// tslint:disable-next-line: no-submodule-imports
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.scss';
import store from './redux/store';
import * as serviceWorker from './serviceWorker';
//import 'bootstrap/dist/css/bootstrap.css';

export default store;
ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                <App />
            </MuiPickersUtilsProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
